import { getSchoolDetailApi } from '@/api/school'
const schoolId = {
  namespaced: true,
  state: {
    schoolInfo: {
      informLink: '',
      informPicUrl: '',
      informText: '',
      schoolBadgeUrl: '',
      schoolDesc: '',
      schoolName: ''
    }
  },
  mutations: {
    setSchoolId (state,context) {
      state.schoolInfo = context
    }
  },
  actions: {
    getSchoolInfo: (context,id) => {
      return new Promise((resolve) => {
        const params = {
          schoolId: id
        }
        getSchoolDetailApi(params).then(data => {
          const { success, result } = data;
          if (success) {
            context.commit('setSchoolId', result);
            resolve(result)
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      })
    }
  }
}
export default schoolId